import { useEffect, useState } from "react";
import { obtenerTurnosMedico, aceptarTurnoMedico, confirmarCambioFecha, rechazarCambioFecha, cancelarTurnoMedico, marcarRealizadoMedico, proponerCambioMedico } from "../services/turnosApi";
import authService from "../service/authService";
import { toast } from "react-toastify";

import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import EventIcon from "@mui/icons-material/Event";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import MedicalServicesRoundedIcon from "@mui/icons-material/MedicalServicesRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import EditCalendarRoundedIcon from "@mui/icons-material/EditCalendarRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

function DashboardTurnos() {
  const [medicoActual, setMedicoActual] = useState(null);
  const [especialidadesMedico, setEspecialidadesMedico] = useState([]);

  const [especialidadSeleccionada, setEspecialidadSeleccionada] =
    useState("todas");

  const [nombrePacienteBusqueda, setNombrePacienteBusqueda] = useState("");

  const [turnos, setTurnos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [cargandoPerfil, setCargandoPerfil] = useState(true);
  const [error, setError] = useState("");
  const [busco, setBusco] = useState(false);
  const [modalCambioAbierto, setModalCambioAbierto] = useState(false);
  const [modalCancelacionAbierto, setModalCancelacionAbierto] = useState(false);
  const [datosCancelacion, setDatosCancelacion] = useState({ idTurno: "", motivo: "", });

  const [datosCambio, setDatosCambio] = useState({
    idTurno: "",
    fecha: "",
    hora: "",
  });

  useEffect(() => {
    async function cargarMedicoActual() {
      try {
        setCargandoPerfil(true);
        setError("");

        const perfil = await authService.obtenerPerfil();

        if (!perfil) {
          throw new Error("No se pudo obtener el usuario autenticado");
        }

        if (perfil.rol !== "MEDICO") {
          throw new Error(
            "El Dashboard de agenda solo está disponible para médicos"
          );
        }

        if (!perfil.medicoId?._id && !perfil.medicoId?.id) {
          throw new Error(
            "El usuario médico no tiene un perfil médico asociado"
          );
        }

        setMedicoActual(perfil);
        setEspecialidadesMedico(
          obtenerEspecialidadesDelPerfil(perfil)
        );
      } catch (errorPerfil) {
        setMedicoActual(null);
        setEspecialidadesMedico([]);
        setError(errorPerfil.message);
        toast.error(errorPerfil.message);
      } finally {
        setCargandoPerfil(false);
      }
    }

    cargarMedicoActual();
  }, []);

  function obtenerEspecialidadesDelPerfil(perfil) {
    const especialidades =
      perfil?.medicoId?.especialidades ||
      perfil?.especialidades ||
      perfil?.medicoId?.especialidad ||
      perfil?.especialidad ||
      [];

    const listaEspecialidades = Array.isArray(especialidades)
      ? especialidades
      : [especialidades];

    return listaEspecialidades
      .map((especialidad) =>
        typeof especialidad === "string"
          ? especialidad
          : especialidad?.nombre
      )
      .filter(Boolean);
  }


  function obtenerIdMedico() {
    return (
      medicoActual?.medicoId?._id ||
      medicoActual?.medicoId?.id ||
      medicoActual?.idMedico ||
      medicoActual?._id ||
      medicoActual?.id
    );
  }

  function normalizarTurno(turno) {
    const fechaHora = turno.fechaHora ? new Date(turno.fechaHora) : null;

    const fecha =
      turno.fecha ||
      (fechaHora && !Number.isNaN(fechaHora.getTime())
        ? fechaHora.toLocaleDateString("es-AR")
        : "");

    const hora =
      turno.hora ||
      (fechaHora && !Number.isNaN(fechaHora.getTime())
        ? fechaHora.toLocaleTimeString("es-AR", {
          hour: "2-digit",
          minute: "2-digit",
        })
        : "");

    return {
      ...turno,
      id: turno.id || turno._id,
      medico:
        turno.medico?.nombre ||
        turno.medicoNombre ||
        turno.medico ||
        medicoActual?.nombre ||
        "Médico",
      paciente:
        turno.paciente?.nombre ||
        turno.pacienteNombre ||
        turno.paciente ||
        "Paciente",
      pacienteId:
        turno.paciente?.id ||
        turno.paciente?._id ||
        turno.pacienteId ||
        "",
      especialidad:
        turno.especialidad?.nombre ||
        turno.especialidad ||
        "Sin especialidad",
      practica:
        turno.practica?.nombre ||
        turno.practica ||
        "Práctica no especificada",
      sede: turno.sede?.nombre || turno.sede || "Sede no especificada",
      estado: turno.estado || "RESERVADO",
      costo: Number(turno.costo ?? turno.costoFinal ?? 0),
      fecha,
      hora,
    };
  }

  async function buscarTurnos() {
    try {
      setCargando(true);
      setError("");
      setBusco(true);

      const idMedico = obtenerIdMedico();

      if (!idMedico) {
        throw new Error("No se pudo identificar al médico autenticado");
      }

      const datos = await obtenerTurnosMedico(
        idMedico,
        [],
        nombrePacienteBusqueda
      );

      const listaTurnos = Array.isArray(datos) ? datos : [];


      const turnosAsignados = listaTurnos.filter((turno) => {
        const practicaTurno =
          typeof turno.practica === "string"
            ? turno.practica
            : turno.practica?.nombre || "";

        const coincidePractica =
          especialidadSeleccionada === "todas" ||
          practicaTurno.trim().toUpperCase() ===
          especialidadSeleccionada.trim().toUpperCase();

        return (
          turno.estado !== "DISPONIBLE" &&
          (turno.pacienteId || turno.paciente) &&
          coincidePractica
        );
      });

      setTurnos(turnosAsignados.map(normalizarTurno));
    } catch (errorBusqueda) {
      setError(errorBusqueda.message);
      setTurnos([]);
      toast.error("Error al cargar los turnos");
    } finally {
      setCargando(false);
    }
  }

  async function aceptarTurno(idTurno) {
    try {
      const idMedico = obtenerIdMedico();

      if (!idMedico) {
        throw new Error("No se pudo identificar al médico");
      }

      await aceptarTurnoMedico(idMedico, idTurno);

      setTurnos((turnosActuales) =>
        turnosActuales.map((turno) =>
          turno.id === idTurno
            ? { ...turno, estado: "CONFIRMADO" }
            : turno
        )
      );

      toast.success("Turno confirmado exitosamente");
    } catch (errorAceptar) {
      toast.error(errorAceptar.message);
    }
  }

  function abrirModalCambio(idTurno) {
    setDatosCambio({
      idTurno,
      fecha: "",
      hora: "",
    });

    setModalCambioAbierto(true);
  }

  function cerrarModalCambio() {
    setModalCambioAbierto(false);

    setDatosCambio({
      idTurno: "",
      fecha: "",
      hora: "",
    });
  }

  async function enviarPropuestaCambio() {
    try {
      if (!datosCambio.fecha || !datosCambio.hora) {
        throw new Error("Tenés que seleccionar una fecha y una hora");
      }

      const idMedico = obtenerIdMedico();

      if (!idMedico) {
        throw new Error("No se pudo identificar al médico");
      }

      await proponerCambioMedico(
        idMedico,
        datosCambio.idTurno,
        datosCambio.fecha,
        datosCambio.hora
      );

      toast.success("Propuesta enviada al paciente");

      cerrarModalCambio();
      await buscarTurnos();
    } catch (error) {
      toast.error(error.message);
    }
  }

  const confirmarCambio = async (idTurno) => {
    try {
      const idMedico = obtenerIdMedico();

      await confirmarCambioFecha(idMedico, idTurno);

      toast.success("Cambio de fecha confirmado");

      buscarTurnos();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const rechazarCambio = async (idTurno) => {
    try {
      const idMedico = obtenerIdMedico();

      await rechazarCambioFecha(idMedico, idTurno);

      toast.success("Cambio de fecha rechazado");

      buscarTurnos();
    } catch (error) {
      toast.error(error.message);
    }
  };

  function abrirModalCancelacion(idTurno) {
    setDatosCancelacion({
      idTurno,
      motivo: "",
    });

    setModalCancelacionAbierto(true);
  }

  function cerrarModalCancelacion() {
    setModalCancelacionAbierto(false);

    setDatosCancelacion({
      idTurno: "",
      motivo: "",
    });
  }

  async function confirmarCancelacion() {
    try {
      const motivo = datosCancelacion.motivo.trim();

      if (!motivo) {
        throw new Error(
          "Tenés que ingresar el motivo de la cancelación"
        );
      }

      const idMedico = obtenerIdMedico();

      if (!idMedico) {
        throw new Error("No se pudo identificar al médico");
      }

      await cancelarTurnoMedico(
        idMedico,
        datosCancelacion.idTurno,
        motivo
      );

      toast.success("Turno cancelado correctamente");

      cerrarModalCancelacion();
      await buscarTurnos();
    } catch (error) {
      toast.error(error.message);
    }
  }
  async function marcarRealizado(idTurno) {
    try {
      const idMedico = obtenerIdMedico();

      await marcarRealizadoMedico(idMedico, idTurno);

      toast.success("Turno marcado como realizado");
      await buscarTurnos();
    } catch (error) {
      toast.error(error.message);
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: "#c9c8c8",
        minHeight: "100vh",
        padding: 3,
      }}
    >
      <Card
        sx={{
          mb: 3,
          backgroundColor: "#fff",
          borderRadius: 1,
          boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
        }}
      >
        <CardContent sx={{ p: 3 }}>

          <Typography
            variant="h4"
            sx={{
              color: "#222",
              fontWeight: 400,
              mb: 1
            }}
          >
            Agenda médica
          </Typography>


          <Typography
            variant="body1"
            color="text.secondary"
          >
            Aquí vas a poder ver los turnos asignados
          </Typography>

        </CardContent>
      </Card>

      <Card
        sx={{
          mb: 3,
          borderRadius: 1,
          boxShadow: "0 1px 4px rgba(0,0,0,0.15)"
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            alignItems="center"
          >
            <FormControl fullWidth>
              <InputLabel id="label-especialidad">
                Especialidad
              </InputLabel>

              <Select
                labelId="label-especialidad"
                value={especialidadSeleccionada}
                label="Especialidad"
                onChange={(evento) =>
                  setEspecialidadSeleccionada(evento.target.value)
                }
                disabled={cargandoPerfil}
              >
                <MenuItem value="todas">
                  Todas mis especialidades
                </MenuItem>

                {especialidadesMedico.map((especialidad) => (
                  <MenuItem
                    key={especialidad}
                    value={especialidad}
                  >
                    {especialidad}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Buscar paciente"
              placeholder="Ej: Juan Pérez"
              value={nombrePacienteBusqueda}
              onChange={(evento) =>
                setNombrePacienteBusqueda(evento.target.value)
              }
              fullWidth
            />


            <Button
              variant="contained"
              color="primary"
              onClick={buscarTurnos}
              disabled={cargando || cargandoPerfil || !medicoActual}
              disableElevation
              sx={{
                minWidth: 160,
                height: 56,
                borderRadius: 2,
              }}
            >
              Buscar turnos
            </Button>

          </Stack>
        </CardContent>
      </Card>

      {cargandoPerfil && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 2,
          }}
        >
          <CircularProgress size={22} />
          <Typography>Cargando perfil del médico...</Typography>
        </Box>
      )}

      {cargando && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 2,
          }}
        >
          <CircularProgress size={22} />
          <Typography>Cargando turnos de la agenda...</Typography>
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {busco &&
        !cargando &&
        !error &&
        turnos.length === 0 && (
          <Alert severity="info" sx={{ mb: 2 }}>
            No se encontraron turnos con los criterios de búsqueda
            ingresados.
          </Alert>
        )}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, minmax(320px, 1fr))",
          gap: 4,
        }}
      >
        {turnos.map((turno) => (
          <Card
            key={turno.id}
            variant="outlined"
            sx={{
              borderRadius: 4,
              overflow: "hidden",
              backgroundColor: "#ffffff",
              boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-6px)",
                borderColor: "primary.main",
                boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
              },
            }}
          >
            <CardContent>
              <Box
                sx={{
                  borderBottom: "1px solid #e0e0e0",
                  pb: 1,
                  mb: 2,
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight={700}
                  color="primary.main"
                >
                  {turno.practica}
                </Typography>

                <Chip
                  label={turno.estado}
                  color={
                    turno.estado === "CANCELADO"
                      ? "error"
                      : turno.estado === "REALIZADO"
                        ? "success"
                        : "primary"
                  }
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1 }}
                />
              </Box>

              <Stack spacing={1.2}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <MedicalServicesRoundedIcon
                    fontSize="small"
                    color="action"
                  />
                  <Typography variant="body2">
                    {turno.medico} ({turno.especialidad})
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <PersonRoundedIcon
                    fontSize="small"
                    color="action"
                  />
                  <Typography variant="body2">
                    Paciente: {turno.paciente}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <EventIcon fontSize="small" color="action" />
                  <Typography
                    variant="body2"
                    fontWeight={600}
                  >
                    {turno.fecha}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <AccessTimeRoundedIcon
                    fontSize="small"
                    color="action"
                  />
                  <Typography
                    variant="body2"
                    fontWeight={700}
                    color="primary.main"
                  >
                    {turno.hora} hs
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <LocationOnRoundedIcon
                    fontSize="small"
                    color="action"
                  />
                  <Typography variant="body2">
                    {turno.sede}
                  </Typography>
                </Box>
              </Stack>

              <Box
                sx={{
                  borderTop: "1px solid #e0e0e0",
                  mt: 2,
                  pt: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    Costo estimado
                  </Typography>

                  <Typography
                    variant="h5"
                    fontWeight={800}
                    color="success.main"
                  >
                    ${turno.costo.toLocaleString("es-AR")}
                  </Typography>
                </Box>
              </Box>

              <Stack spacing={1} sx={{ mt: 2 }}>
                {turno.estado === "RESERVADO" && (
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => aceptarTurno(turno.id)}
                  >
                    Aceptar
                  </Button>
                )}

                {turno.estado === "PENDIENTE" &&
                  turno.propuestoPor === "PACIENTE" && (
                    <>
                      <Typography variant="body2" color="primary">
                        Nueva fecha: {turno.fechaPropuesta} {turno.horaPropuesta}
                      </Typography>

                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={() => confirmarCambio(turno.id)}
                      >
                        Aceptar cambio
                      </Button>

                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => rechazarCambio(turno.id)}
                      >
                        Rechazar cambio
                      </Button>
                    </>
                  )}
                {turno.estado === "PENDIENTE" &&
                  turno.propuestoPor === "MEDICO" && (
                    <>
                      <Typography variant="body2" color="text.secondary">
                        Esperando respuesta del paciente
                      </Typography>

                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => abrirModalCancelacion(turno.id)}
                      >
                        Cancelar turno
                      </Button>
                    </>
                  )}

                {(turno.estado === "RESERVADO" ||
                  turno.estado === "CONFIRMADO") && (
                    <>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<CancelRoundedIcon />}
                        onClick={() => abrirModalCancelacion(turno.id)}
                      >
                        Cancelar turno
                      </Button>

                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<EditCalendarRoundedIcon />}
                        onClick={() =>
                          abrirModalCambio(turno.id)}
                      >
                        Proponer cambio
                      </Button>
                    </>
                  )}

                {turno.estado === "CONFIRMADO" && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<CheckCircleRoundedIcon />}
                    onClick={() =>
                      marcarRealizado(
                        turno.id,
                        "REALIZADO",
                        "Turno marcado como realizado con éxito."
                      )
                    }
                  >
                    Marcar realizado
                  </Button>
                )}
              </Stack>
            </CardContent>
          </Card>
        ))}

        <Dialog
          open={modalCambioAbierto}
          onClose={cerrarModalCambio}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Proponer nueva fecha</DialogTitle>

          <DialogContent>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Elegí una nueva fecha y horario para enviarle la propuesta al paciente.
            </Typography>

            <Stack spacing={2} sx={{ mt: 1 }}>
              <Typography variant="body2">
                Nueva fecha
              </Typography>

              <TextField
                type="date"
                value={datosCambio.fecha}
                onChange={(evento) =>
                  setDatosCambio((datosActuales) => ({
                    ...datosActuales,
                    fecha: evento.target.value,
                  }))
                }
                fullWidth
              />

              <Typography variant="body2">
                Nueva hora
              </Typography>

              <TextField
                type="time"
                value={datosCambio.hora}
                onChange={(evento) =>
                  setDatosCambio((datosActuales) => ({
                    ...datosActuales,
                    hora: evento.target.value,
                  }))
                }
                fullWidth
              />
            </Stack>
          </DialogContent>

          <DialogActions>
            <Button onClick={cerrarModalCambio}>
              Volver
            </Button>

            <Button
              variant="contained"
              onClick={enviarPropuestaCambio}
              disabled={!datosCambio.fecha || !datosCambio.hora}
            >
              Enviar propuesta
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={modalCancelacionAbierto}
          onClose={cerrarModalCancelacion}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Cancelar turno</DialogTitle>

          <DialogContent>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 2 }}
            >
              Escribí el motivo de la cancelación.
            </Typography>

            <TextField
              label="Motivo de cancelación"
              placeholder="Ej: No podré atender en ese horario"
              value={datosCancelacion.motivo}
              onChange={(evento) =>
                setDatosCancelacion((datosActuales) => ({
                  ...datosActuales,
                  motivo: evento.target.value,
                }))
              }
              multiline
              minRows={3}
              fullWidth
              autoFocus
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={cerrarModalCancelacion}>
              Volver
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={confirmarCancelacion}
              disabled={!datosCancelacion.motivo.trim()}
            >
              Confirmar cancelación
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}

export default DashboardTurnos;